var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4316",
    "data-name": "Group 4316",
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.906,
    height: 90.252,
    viewBox: "0 0 275.906 90.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14042",
    "data-name": "Path 14042",
    d: "M372.547,1013.88a12.2,12.2,0,0,1-12.194,12.2H108.838a12.2,12.2,0,0,1-12.2-12.2V948.021a12.2,12.2,0,0,1,12.2-12.2H360.353a12.2,12.2,0,0,1,12.194,12.2Z",
    transform: "translate(-96.641 -935.825)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(18.508 14.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14043",
    "data-name": "Path 14043",
    d: "M185.078,1020.952a44.7,44.7,0,0,1-4.04,7.543c-2.625,3.995-6.322,8.969-10.9,9.012-4.073.038-5.118-2.651-10.644-2.62s-6.68,2.667-10.753,2.63c-4.582-.042-8.087-4.534-10.711-8.529-7.338-11.17-8.1-24.278-3.579-31.247,3.216-4.953,8.289-7.851,13.059-7.851,4.857,0,7.911,2.664,11.926,2.664,3.895,0,6.27-2.668,11.884-2.668,4.245,0,8.742,2.311,11.947,6.308C172.764,1001.946,174.469,1016.943,185.078,1020.952Z",
    transform: "translate(-131.637 -975.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4311",
    "data-name": "Group 4311",
    transform: "translate(25.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14044",
    "data-name": "Path 14044",
    d: "M189.941,972.452a13.632,13.632,0,0,0,3.027-10.1,14.729,14.729,0,0,0-9.508,5.114c-2.066,2.51-3.771,6.232-3.107,9.849A12.431,12.431,0,0,0,189.941,972.452Z",
    transform: "translate(-180.207 -962.355)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4315",
    "data-name": "Group 4315",
    transform: "translate(83.791 14.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4313",
    "data-name": "Group 4313",
    transform: "translate(0 21.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14045",
    "data-name": "Path 14045",
    d: "M265.593,1004.42l-10.511,30.94H259.9l3.138-9.5H273.21l3.227,9.5h4.946l-10.556-30.94Zm2.494,5.087c.355,1.381.738,2.815,1.23,4.365l2.833,8.2h-8.062l2.793-8.258C267.306,1012.48,267.71,1011.034,268.087,1009.507Z",
    transform: "translate(-255.082 -1003.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14046",
    "data-name": "Path 14046",
    d: "M319.924,1019.586a8.759,8.759,0,0,0-7.442,3.57l-.187-3.077h-4.282l.025.393c.126,1.917.179,4.027.179,7.057v23.848H312.9v-11.129a8.22,8.22,0,0,0,6.4,2.749,9.65,9.65,0,0,0,7.093-3.016,12.789,12.789,0,0,0,3.132-9,12.452,12.452,0,0,0-2.719-8.221A8.907,8.907,0,0,0,319.924,1019.586Zm-1.166,3.875c4.173,0,6.041,3.866,6.041,7.7,0,4.941-2.383,8.01-6.218,8.01a5.675,5.675,0,0,1-5.515-4.344,5.971,5.971,0,0,1-.166-1.515v-3.764a7.049,7.049,0,0,1,.149-1.156c.023-.128.049-.256.067-.38A5.928,5.928,0,0,1,318.758,1023.461Z",
    transform: "translate(-280.021 -1011.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14047",
    "data-name": "Path 14047",
    d: "M365.505,1019.586a8.763,8.763,0,0,0-7.442,3.57l-.187-3.077H353.6l.024.393c.127,1.919.18,4.027.18,7.057v23.848h4.681v-11.129a8.216,8.216,0,0,0,6.4,2.749,9.663,9.663,0,0,0,7.1-3.016,12.8,12.8,0,0,0,3.13-9,12.453,12.453,0,0,0-2.721-8.221A8.9,8.9,0,0,0,365.505,1019.586Zm-1.165,3.875c4.171,0,6.039,3.866,6.039,7.7,0,4.941-2.385,8.01-6.218,8.01a5.675,5.675,0,0,1-5.515-4.344,5.977,5.977,0,0,1-.165-1.515v-3.764a6.949,6.949,0,0,1,.149-1.159c.023-.126.047-.252.068-.376A5.924,5.924,0,0,1,364.34,1023.461Z",
    transform: "translate(-301.497 -1011.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14048",
    "data-name": "Path 14048",
    d: "M423.289,1017.091c-4.369-1.692-5.769-3.022-5.769-5.48,0-2.07,1.645-4.158,5.321-4.158a10.637,10.637,0,0,1,5.5,1.38l.4.245,1.321-3.907-.261-.153a13.568,13.568,0,0,0-6.817-1.529c-5.97,0-10.139,3.524-10.139,8.568,0,4.068,2.611,6.912,8.216,8.95,3.973,1.485,5.451,3.006,5.451,5.614,0,2.951-2.281,4.783-5.95,4.783a12.811,12.811,0,0,1-6.747-1.913l-.406-.26-1.257,4,.231.153a16.035,16.035,0,0,0,7.911,2.033c8.045,0,10.9-4.906,10.9-9.106C431.185,1021.975,428.9,1019.3,423.289,1017.091Z",
    transform: "translate(-329.082 -1003.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14049",
    "data-name": "Path 14049",
    d: "M457,1010.439l-4.591,1.441v3.889h-3.361v3.741h3.361v11.46c0,2.77.53,4.712,1.621,5.939a6,6,0,0,0,4.529,1.778,11.032,11.032,0,0,0,3.618-.558l.262-.093-.224-3.748-.449.138a7.05,7.05,0,0,1-2.177.252c-1.814,0-2.589-1.147-2.589-3.842V1019.51h5.647v-3.741H457Z",
    transform: "translate(-346.468 -1006.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14050",
    "data-name": "Path 14050",
    d: "M486.785,1019.586c-6.55,0-11.123,4.889-11.123,11.885,0,6.787,4.426,11.526,10.765,11.526h.043c5.358,0,11.123-3.733,11.123-11.929a11.826,11.826,0,0,0-2.983-8.28A10.417,10.417,0,0,0,486.785,1019.586Zm-.135,3.7c4.211,0,6.128,4.105,6.128,7.922,0,4.693-2.616,8.1-6.217,8.1h-.046c-3.55,0-6.127-3.349-6.127-7.963C480.389,1027.329,482.326,1023.282,486.65,1023.282Z",
    transform: "translate(-359.008 -1011.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14051",
    "data-name": "Path 14051",
    d: "M533.863,1019.8l-.281-.071a4.51,4.51,0,0,0-1.164-.146,6.678,6.678,0,0,0-5.869,3.769l-.138-3.276h-4.2l.027.393c.125,1.853.177,3.933.177,6.741l-.043,15.292h4.681v-11.93a12.064,12.064,0,0,1,.129-1.814c.528-2.865,2.462-4.717,4.925-4.717a12,12,0,0,1,1.256.078l.5.052Z",
    transform: "translate(-380.94 -1011.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14052",
    "data-name": "Path 14052",
    d: "M554.715,1019.5c-6.231,0-10.584,4.979-10.584,12.109,0,6.866,4.33,11.3,11.032,11.3a17.952,17.952,0,0,0,7.411-1.422l.282-.127-.9-3.488-.39.158a14.508,14.508,0,0,1-5.865,1.049c-2.034,0-6.724-.671-7.011-6.787l15.109.046.061-.3a10.4,10.4,0,0,0,.141-1.954C564,1025.2,561.569,1019.5,554.715,1019.5Zm-.312,3.561a4.619,4.619,0,0,1,3.437,1.311,6.663,6.663,0,0,1,1.612,4.358H548.776C549.211,1026.029,550.9,1023.063,554.4,1023.063Z",
    transform: "translate(-391.268 -1011.033)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4314",
    "data-name": "Group 4314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14053",
    "data-name": "Path 14053",
    d: "M255.082,964.185a34.12,34.12,0,0,1,4.49-.3c3.018,0,5.167.608,6.591,1.8a6.408,6.408,0,0,1,2.318,5.279,7.412,7.412,0,0,1-2.342,5.692c-1.545,1.369-4.056,2.108-7.218,2.108a32.471,32.471,0,0,1-3.839-.174Zm2.125,12.971a15.083,15.083,0,0,0,2.124.087c4.49.021,6.928-2.26,6.928-6.213.024-3.5-2.149-5.649-6.59-5.649a13.346,13.346,0,0,0-2.462.2Z",
    transform: "translate(-255.082 -963.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14054",
    "data-name": "Path 14054",
    d: "M289.664,982.433a5.278,5.278,0,0,1-5.6-5.41c0-3.519,2.583-5.584,5.794-5.584,3.356,0,5.624,2.194,5.624,5.388,0,3.91-3.017,5.605-5.793,5.605Zm.072-1.434c2.028,0,3.549-1.716,3.549-4.107,0-1.781-.99-4.019-3.5-4.019-2.487,0-3.573,2.086-3.573,4.085,0,2.3,1.449,4.041,3.5,4.041Z",
    transform: "translate(-268.737 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14055",
    "data-name": "Path 14055",
    d: "M310.074,971.891l1.569,5.323c.313,1.173.628,2.281.845,3.367h.072c.266-1.065.652-2.194,1.038-3.345l1.907-5.345h1.787l1.811,5.257c.434,1.239.772,2.368,1.038,3.433h.072a29.092,29.092,0,0,1,.893-3.411l1.665-5.28h2.1l-3.766,10.515h-1.931l-1.786-5.018a34.461,34.461,0,0,1-1.039-3.476H316.3a28.884,28.884,0,0,1-1.063,3.5l-1.882,5h-1.931L307.9,971.891Z",
    transform: "translate(-279.967 -966.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14056",
    "data-name": "Path 14056",
    d: "M343.925,974.525c0-1.108-.024-1.977-.1-2.846h1.884l.12,1.717h.049a4.425,4.425,0,0,1,3.862-1.956c1.617,0,4.128.868,4.128,4.475v6.279h-2.123v-6.061c0-1.695-.7-3.128-2.705-3.128a3.03,3.03,0,0,0-2.848,1.955,2.575,2.575,0,0,0-.145.891v6.344h-2.124Z",
    transform: "translate(-296.895 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M369.346,962.607h2.124v15.425h-2.124Z",
    transform: "translate(-308.918 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M384.032,982.433a5.278,5.278,0,0,1-5.6-5.41c0-3.519,2.581-5.584,5.794-5.584,3.354,0,5.624,2.194,5.624,5.388,0,3.91-3.018,5.605-5.794,5.605ZM384.1,981c2.028,0,3.55-1.716,3.55-4.107,0-1.781-.99-4.019-3.5-4.019-2.487,0-3.574,2.086-3.574,4.085,0,2.3,1.449,4.041,3.5,4.041Z",
    transform: "translate(-313.198 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M412.506,979.674a15.846,15.846,0,0,0,.17,2.519h-1.908l-.193-1.324H410.5a4.492,4.492,0,0,1-3.573,1.564c-2.365,0-3.573-1.5-3.573-3.02,0-2.542,2.51-3.932,7.024-3.911v-.217c0-.869-.264-2.455-2.655-2.433a6.1,6.1,0,0,0-3.066.782l-.483-1.281a8.229,8.229,0,0,1,3.863-.912c3.6,0,4.465,2.194,4.465,4.3Zm-2.075-2.846c-2.317-.043-4.949.326-4.949,2.368a1.776,1.776,0,0,0,1.979,1.826,2.946,2.946,0,0,0,2.872-1.761,1.756,1.756,0,0,0,.1-.608Z",
    transform: "translate(-324.942 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14060",
    "data-name": "Path 14060",
    d: "M436.431,962.607v12.709c0,.934.026,2,.1,2.716h-1.906l-.1-1.825h-.049a4.372,4.372,0,0,1-3.959,2.064,5.014,5.014,0,0,1-5.022-5.345,5.242,5.242,0,0,1,5.238-5.648,4.018,4.018,0,0,1,3.526,1.586h.048v-6.257Zm-2.124,9.19a3.183,3.183,0,0,0-.1-.825,3.071,3.071,0,0,0-3.065-2.195c-2.2,0-3.5,1.738-3.5,4.042,0,2.15,1.184,3.91,3.452,3.91a3.161,3.161,0,0,0,3.114-2.281,2.979,2.979,0,0,0,.1-.826Z",
    transform: "translate(-335.372 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14061",
    "data-name": "Path 14061",
    d: "M466.521,982.433a5.278,5.278,0,0,1-5.6-5.41c0-3.519,2.585-5.584,5.794-5.584,3.357,0,5.625,2.194,5.625,5.388,0,3.91-3.018,5.605-5.792,5.605Zm.073-1.434c2.028,0,3.548-1.716,3.548-4.107,0-1.781-.988-4.019-3.5-4.019-2.487,0-3.573,2.086-3.573,4.085,0,2.3,1.448,4.041,3.5,4.041Z",
    transform: "translate(-352.063 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14062",
    "data-name": "Path 14062",
    d: "M487.5,974.525c0-1.108-.025-1.977-.1-2.846h1.883l.122,1.717h.048a4.425,4.425,0,0,1,3.862-1.956c1.618,0,4.129.868,4.129,4.475v6.279h-2.125v-6.061c0-1.695-.7-3.128-2.7-3.128a3.034,3.034,0,0,0-2.849,1.955,2.587,2.587,0,0,0-.144.891v6.344H487.5Z",
    transform: "translate(-364.538 -966.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14063",
    "data-name": "Path 14063",
    d: "M523.971,967.127v2.519h3.041V971.1h-3.041v5.671c0,1.3.411,2.042,1.593,2.042a4.37,4.37,0,0,0,1.231-.131l.1,1.455a6.385,6.385,0,0,1-1.883.261,3.217,3.217,0,0,1-2.294-.8,3.817,3.817,0,0,1-.82-2.76V971.1h-1.811v-1.455h1.811v-1.933Z",
    transform: "translate(-379.938 -964.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14064",
    "data-name": "Path 14064",
    d: "M537.705,962.607h2.124v6.561h.049a3.606,3.606,0,0,1,1.521-1.347,4.483,4.483,0,0,1,2.173-.543c1.568,0,4.079.868,4.079,4.5v6.257h-2.124v-6.039c0-1.717-.7-3.128-2.7-3.128a3.053,3.053,0,0,0-2.849,1.912,2.1,2.1,0,0,0-.145.912v6.344h-2.124Z",
    transform: "translate(-388.24 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14065",
    "data-name": "Path 14065",
    d: "M563.494,977.242c.05,2.586,1.86,3.651,3.984,3.651a8.859,8.859,0,0,0,3.237-.522l.386,1.347a10.448,10.448,0,0,1-3.911.674c-3.574,0-5.747-2.151-5.747-5.3a5.354,5.354,0,0,1,5.5-5.693c3.815,0,4.8,3.02,4.8,4.954a4.415,4.415,0,0,1-.071.912Zm6.206-1.369a2.821,2.821,0,0,0-2.922-3.107,3.307,3.307,0,0,0-3.259,3.107Z",
    transform: "translate(-399.424 -966.749)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp3);
export default __webpack_public_path__ + "static/media/app3.62d1b3b19095d12e9dc0f36662370ae7.svg";
export { ForwardRef as ReactComponent };